window.nffleet_events = {
    destroy: function() {
        return createEvent(window.nffleet_variables.destroyListener);
    },
    formSubmitted: function() {
        return createEvent(window.nffleet_variables.formSubmittedListener);
    }
};

function createEvent(eventName) {
    var event;
    if (typeof (Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
}